import { useState } from 'react';

import { HOW_IT_WORKS_STEPS } from '../../constants/howItWorks';

import HiwStepItemCollapsible from './HiwStepItemCollapsible';

import './HiwStepsMobile.scss';

const HiwStepsMobile = () => {
  const [indexOpened, setIndexOpened] = useState(0);

  const handleCollapseChange = (collapsed, index) => {
    setIndexOpened(collapsed ? null : index);
  };

  return (
    <section className="hiw-steps-mobile">
      {HOW_IT_WORKS_STEPS.map(
        (
          { titleKey, descriptionKey, bulletPoints, renderImage, cta },
          index
        ) => (
          <HiwStepItemCollapsible
            stepNumber={index + 1}
            key={titleKey}
            titleKey={titleKey}
            descriptionKey={descriptionKey}
            bulletPoints={bulletPoints}
            renderImage={renderImage}
            cta={cta}
            isCollapsed={indexOpened !== index}
            onCollapsedChange={collapsed =>
              handleCollapseChange(collapsed, index)
            }
          />
        )
      )}
    </section>
  );
};

export default HiwStepsMobile;
